import React from 'react';
import styled from 'styled-components';

export const ImagePlaceholder: React.FC = () => <StyledImagePlaceholder>Upload image</StyledImagePlaceholder>;

const StyledImagePlaceholder = styled.div`
  background-color: #f5f6f7;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  display: grid;
  margin: 0 auto;
  font-size: 10px;
  overflow: hidden;
  font-weight: normal;
`;
